module.exports = __webpack_public_path__ + "media/packs/images/attention-7d2718a2fa105cb8495be80ad12fa4a8.svg";